import React, { memo } from 'react';
import { Blok } from '../../../interfaces/Blok.interface';
import { FormFieldBlokProps } from '../FormFieldBlokProps.interface';
import Grid from '../../Utils/Grid/Grid';
import Col from '../../Utils/Col/Col';
import { StoryblokComponent } from 'gatsby-source-storyblok';

export interface FormFieldRowBlokProps extends Blok {
  left_column_form_field: FormFieldBlokProps[];
  right_column_form_field: FormFieldBlokProps[];
}

interface FormFieldRowProps {
  blok: FormFieldRowBlokProps;
}

const FormFieldRow: React.FC<FormFieldRowProps> = ({ blok }) => {
  const { left_column_form_field, right_column_form_field } = blok;

  return (
    <Grid>
      <Col span={{ default: 6 }}>
        {left_column_form_field.map((form_field: FormFieldBlokProps) => (
          <StoryblokComponent blok={form_field} key={form_field._uid} />
        ))}
      </Col>
      <Col span={{ default: 6 }}>
        {right_column_form_field.map((form_field: FormFieldBlokProps) => (
          <StoryblokComponent blok={form_field} key={form_field._uid} />
        ))}
      </Col>
    </Grid>
  );
};

export default memo(FormFieldRow);
